module.exports = __webpack_public_path__ + "img/vovice-1.70fed487.svg";